import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  LogOut,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  IdCard,
} from "lucide-react";
import { APP_ROUTES } from "../constants/approutes";
import { callMedsVerifyPasswordApi } from "../utils/medsPortalAuth";
import dashboardIcon from "../assets/dashboardicon.svg";
import dashboardActiveIcon from "../assets/dashboardactiveicon.svg";
import patientIcon from "../assets/patientregistericon.svg";
import patientActiveIcon from "../assets/patientregisteractiveicon.svg";
import bookServiceIcon from "../assets/bookserviceicon.svg";
import bookServiceActiveIcon from "../assets/bookserviceactiveicon.svg";
import queueIcon from "../assets/queueicon.svg";
import queueActiveIcon from "../assets/queueactiveicon.svg";
import reportsIcon from "../assets/reports.svg";
import reportsActiveIcon from "../assets/reportsactiveicon.svg";
import paymentIcon from "../assets/payment.svg";
import doctorIcon from "../assets/doct.svg";
import clinicStaffIcon from "../assets/clinic.svg";
import paymentActiveIcon from "../assets/paymentActiveIcon.svg";
import doctorActiveIcon from "../assets/doctorActiveIcon.svg";
import clinicStaffActiveIcon from "../assets/clinicStaffActiveIcon.svg";
import doctorListIcon from "../assets/doctorlist.svg";
import receptionistListIcon from "../assets/receptionist.svg";
import clinicOnboardingIcon from "../assets/cliniconbo.svg";
import doctorListActiveIcon from "../assets/doctoract.svg";
import receptionistListActiveIcon from "../assets/receptionact.svg";
import clinicOnboardingActiveIcon from "../assets/clinicact.svg";
import overview from "../assets/overview.svg";
import b2bMedicineOrderIcon from "../assets/b2bicon.svg";
import doctorOnboardingIcon from "../assets/doctor onboard.svg";
import doctorListIcons from "../assets/doctor list.svg";
import leaveManagementIcon from "../assets/leave management.svg";
import appointmentPendingIcon from "../assets/appointment pending.svg";
import consultationPendingIcon from "../assets/consultation pending.svg";
import patientFeedbackIcon from "../assets/patient feedback.svg";
import serviceicon from "../assets/serviceicon.svg";
import abhaicon from "../assets/abhaicon.svg";
import quantumicon from "../assets/quantumicon.svg";
import occularicon from "../assets/occularicon.svg";
import kavachicon from "../assets/kavachiconnew.svg";
import { getHospitalDetails } from "../utils/hospitalStorage";
import insuranceicon from "../assets/insuranceicon.svg";
import { openNhcxSso } from "../utils/nhcxSso";
function isExternalHref(href) {
  return typeof href === "string" && /^https?:\/\//i.test(href);
}

const ABHA_BASE_URL =
  process.env.REACT_APP_ABHA_URL ;

const getAbhaLoginUrl = () => {
  const base = String(ABHA_BASE_URL).replace(/\/$/, "");
  const hospital = getHospitalDetails();
  const email =
    hospital?.email ||
    localStorage.getItem("email") ||
    "";
  return `${base}/login?email=${encodeURIComponent(email)}`;
};

const getPatientsPortalBase = () => {
  const apiUrl =
    process.env.REACT_APP_API_URL_PATIENTS_FRONTEND || "";
  return String(apiUrl).replace(/\/?$/, "");
};

const TreeSubmenuIcon = ({ subItem }) => {
  if (subItem.icon) {
    return (
      <img
        src={subItem.icon}
        alt=""
        className="w-4 h-4 shrink-0 object-contain"
      />
    );
  }
  return <IdCard size={16} strokeWidth={2} className="shrink-0 text-white" />;
};

export default function Sidebar({ collapsed, setCollapsed, onNavigate }) {
  const location = useLocation();
  const role = localStorage.getItem("role");
  const roleList = useMemo(
    () => (role || "").split(",").map((r) => r.trim()).filter(Boolean),
    [role]
  );
  const hasRole = (r) => roleList.includes(r);
  const tenantId = localStorage.getItem("tenantId") || "";
  console.log(tenantId,"tenantId")
  const disabledFeatures = JSON.parse(localStorage.getItem("disabledFeatures") || "[]");
  const hospitalid = localStorage.getItem("hospitalid") || "";
  const hospitaluserId = localStorage.getItem("HospitaluserId") || "";

  const navigation = useMemo(() => {
    const userMenu = [
      {
        name: "Organization Overview",
        href: "/dashboard",
        icon: dashboardIcon,
        activeIcon: dashboardActiveIcon,
      },
      ...(hospitaluserId
        ? [
            {
              name: "Service Offerings",
              icon: serviceicon,
              activeIcon: serviceicon,
              submenuStyle: "tree",
              submenu: [
                { name: "B2B Medicine Order", medsApi: true, icon: b2bMedicineOrderIcon },
                { name: "B2B Ocular Order", medsApi: true, icon: occularicon },
                { name: "ABHA", abhaLogin: true, icon: abhaicon },
                  { name: "NHCX Insurance Claims", nhcxSso: true, icon: insuranceicon },
                { name: "Kavach Enrollment", href: APP_ROUTES.KAVACH_ENROLLMENT, icon: kavachicon },
                { name: "AI Pre screening", aiPreScreening: true, icon: quantumicon },
              ],
            },
          ]
        : []),
      {
        name: "Patient Registration",
        href: "/Patientregister",
        icon: patientIcon,
        activeIcon: patientActiveIcon,
      },
      ...(!disabledFeatures.includes("schedule-service") ? [{
        name: "Schedule Service",
        href: "/BookService",
        icon: bookServiceIcon,
        activeIcon: bookServiceActiveIcon,
      }] : []),
      {
        name: "Queue management",
        href: "/QueueManagement",
        icon: queueIcon,
        activeIcon: queueActiveIcon,
      },
      ...(hospitaluserId ? [{
        name: "Surgery Enquiry",
        href: "/camp-details",
        icon: clinicStaffIcon,
        activeIcon: clinicStaffActiveIcon,
      }] : []),
      {
        name: " Patient List ",
        href: "/patientList",
        icon: clinicStaffIcon,
        activeIcon: clinicStaffActiveIcon,
      },
      {
        name: "Payment & Invoices",
        href: "/PaymentDetails",
        icon: paymentIcon,
        activeIcon: paymentActiveIcon,
      },
    ];

    const adminMenu = [
      {
        name: "Reports & Insights",
        href: "/reports",
        icon: reportsIcon,
        activeIcon: reportsActiveIcon,
      },
      {
        name: "Payment & Invoices",
        href: "/PaymentDetails",
        icon: paymentIcon,
        activeIcon: paymentActiveIcon,
      },
      {
        name: " Organization Onboarding",
        href: "/clinicOnboarding",
        icon: clinicOnboardingIcon,
        activeIcon: clinicOnboardingActiveIcon,
      },
      {
        name: "Doctor",
        icon: doctorIcon,
        activeIcon: doctorActiveIcon,
        submenuStyle: "tree",
        submenu: [
          { name: "Doctor Onboard", href: "/DoctorOnboarding", icon: doctorIcon },
          { name: "Doctor List", href: "/DoctorList", icon: doctorListIcon },
        ],
      },
      {
        name: "Receptionist",
        icon: receptionistListIcon,
        activeIcon: receptionistListActiveIcon,
        submenuStyle: "tree",
        submenu: [
          { name: "Receptionist Onboarding", href: "/clinicStaffOB", icon: clinicStaffIcon },
          { name: "Receptionist List", href: "/receptionistList", icon: receptionistListIcon },
        ],
      },
    ];

    const curebayAdminMenu = [
      {
        name: " Consultation List ",
        href: "/ConsultationList",
        icon: consultationPendingIcon,
        activeIcon: consultationPendingIcon,
      },
      {
        name: " Doctor Onboarding ",
        href: "/CurebayDoctorOnboarding",
        icon: doctorOnboardingIcon,
        activeIcon: doctorOnboardingIcon,
      },
      {
        name: " Doctor List ",
        href: "/CurebayDoctorList",
        icon: doctorListIcons,
        activeIcon: doctorListIcons,
      },
      {
        name: " Appointment Pending List ",
        href: "/PatientPendingList",
        icon: appointmentPendingIcon,
        activeIcon: appointmentPendingIcon,
      },
      {
        name: "Leave Management ",
        href: "/CurebayLeave",
        icon: leaveManagementIcon,
        activeIcon: leaveManagementIcon,
      },
      
    ];

    const superAdminMenu = [
      {
        name: " Admin Onboarding",
        href: "/adminOnboarding",
        icon: clinicOnboardingIcon,
        activeIcon: clinicOnboardingActiveIcon,
      },
      {
        name: " Admin List ",
        href: "/adminList",
        icon: receptionistListIcon,
        activeIcon: receptionistListActiveIcon,
      },
    ];

    const financeMenu = [
      {
        name: " Doctor List ",
        href: "/CurebayDoctorList",
        icon: doctorListIcons,
        activeIcon: doctorListIcons,
      },
      {
        name: " Hospital List",
        href: "/hospitalList",
        icon: clinicOnboardingIcon,
        activeIcon: clinicOnboardingActiveIcon,
      },
      {
        name: " Doctor Payments ",
        href: "/CurebayDoctorPayments",
        icon: paymentIcon,
        activeIcon: paymentActiveIcon,
      },
    ];

    const businessMenu = [
      {
        name: " Hospital List",
        href: "/hospitalList",
        icon: clinicOnboardingIcon,
        activeIcon: clinicOnboardingActiveIcon,
      },
    ];

    let combined = [];
    if (hasRole("USER")) combined = combined.concat(userMenu);
    if (hasRole("ADMIN")) {
      combined = combined.concat(
        tenantId?.trim() === "CureBay" ? curebayAdminMenu : adminMenu
      );
    }
    if (hasRole("SUPERADMIN")) combined = combined.concat(superAdminMenu);
    if (hasRole("FINANCE")) combined = combined.concat(financeMenu);
    if (hasRole("BUSINESS")) combined = combined.concat(businessMenu);

    const seen = new Set();
    return combined.filter((item) => {
      if (seen.has(item.name)) return false;
      seen.add(item.name);
      return true;
    });
  }, [role, tenantId, hospitalid, hospitaluserId, disabledFeatures]);

  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
  });

  const [expandedMenus, setExpandedMenus] = useState({});
  const [medsApiLoading, setMedsApiLoading] = useState(false);
  const [nhcxSsoLoading, setNhcxSsoLoading] = useState(false);

  const handleMedsApiClick = async (e) => {
    e.preventDefault();
    if (medsApiLoading) return;
    setMedsApiLoading(true);
    try {
      const { loginUrl } = await callMedsVerifyPasswordApi();

      console.log("Meds SSO URL:", loginUrl);
      if (onNavigate) onNavigate();
    } catch (error) {
      toast.error(error?.message || "Failed to open B2B portal.");
    } finally {
      setMedsApiLoading(false);
    }
  };

  const handleAbhaLoginClick = () => {
    const url = getAbhaLoginUrl();
    if (!url) {
      toast.error("ABHA login URL is not configured. Set REACT_APP_ABHA_URL and restart the app.");
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
    if (onNavigate) onNavigate();
  };
  const handleNhcxSsoClick = async (e) => {
    e.preventDefault();
    if (nhcxSsoLoading) return;
    setNhcxSsoLoading(true);
    try {
      await openNhcxSso();
      if (onNavigate) onNavigate();
    } catch (error) {
      toast.error(error?.message || "Failed to open NHCX Insurance Claims.");
    } finally {
      setNhcxSsoLoading(false);
    }
  };

  const handleAiPreScreeningClick = () => {
    const base = String(process.env.REACT_APP_QUANTUM_URL || "").replace(/\/$/, "");
    if (!base) {
      toast.error("Quantum URL is not configured. Set REACT_APP_QUANTUM_URL and restart the app.");
      return;
    }
    window.open(`${base}/`, "_blank", "noopener,noreferrer");
    if (onNavigate) onNavigate();
  };

  useEffect(() => {
    if (hospitalid) {
      setExpandedMenus((prev) => ({ ...prev, "Service Offerings": true }));
    }
  }, [hospitalid]);

  useEffect(() => {
    const firstName = localStorage.getItem("firstName") || "";
    const lastName = localStorage.getItem("lastName") || "";
    const mobile = localStorage.getItem("mobile") || "";
    setUserInfo({ firstName, lastName, mobile });
  }, []);

  if (location.pathname.startsWith("/caresathi")) {
    return null;
  }

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");

      await fetch(`${process.env.REACT_APP_API_URL}auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });
      localStorage.removeItem("auth_token");
      localStorage.removeItem("meds_jwt_token");
      localStorage.removeItem("meds_refresh_token");
      localStorage.removeItem("meds_auth_response");
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const toggleSidebar = () => setCollapsed(!collapsed);

  return (
    <div
      className={`h-screen bg-gradient-to-b from-[#004276] to-[#00BD7F] text-white flex flex-col transition-all duration-300 ease-in-out ${collapsed ? "w-20" : "w-64"
        }`}
    >
      <div className="flex-shrink-0">
        <div className="flex items-center justify-between px-4 py-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-pink-300 flex items-center justify-center text-white font-semibold text-lg uppercase">
              {userInfo?.firstName?.charAt(0) || ""}
            </div>
            {!collapsed && (
              <div>
                <div className="text-sm font-semibold">
                  {userInfo?.firstName} {userInfo?.lastName == null || userInfo?.lastName == "" ? userInfo?.lastName : ""}
                </div>
                <div className="text-xs text-gray-300">{userInfo?.mobile}</div>
              </div>
            )}
          </div>
          <button
            onClick={toggleSidebar}
            className="text-white hover:text-gray-300 transition ml-2"
          >
            {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
          </button>
        </div>
      </div>

      <nav className="flex-1 min-h-0 overflow-y-auto mt-4">
          <ul className="space-y-2 px-2">
            {navigation.map((item) => {
              const isActive =
                location.pathname === item.href ||
                (item.submenu &&
                  item.submenu.some(
                    (sub) => !isExternalHref(sub.href) && location.pathname === sub.href
                  ));
              const icon = isActive ? item.activeIcon : item.icon;
              const hasSubmenu = item.submenu && item.submenu.length > 0;
              const isExpanded = expandedMenus[item.name];

              return (
                <li key={item.name}>
                  {hasSubmenu ? (
                    <>
                      <button
                        type="button"
                        aria-expanded={isExpanded}
                        onClick={() => {
                          setExpandedMenus(prev => ({
                            ...prev,
                            [item.name]: !prev[item.name]
                          }));
                        }}
                        title={collapsed ? item.name : ""}
                        className={`flex items-center ${collapsed ? "justify-center" : "justify-between"
                          } w-full px-4 py-2 text-sm font-medium rounded-lg transition ${isActive
                            ? "bg-emerald-400/50 text-white font-semibold shadow-sm"
                            : "hover:bg-white/10 text-white"
                          }`}
                      >
                        <div className={`flex items-center ${collapsed ? "" : "gap-3"}`}>
                          <div
                            className={`w-10 h-10 flex items-center justify-center rounded-lg ${isActive ? "bg-white/90" : ""
                              }`}
                          >
                            <img
                              src={icon}
                              width={20}
                              height={20}
                              alt={item.name}
                              className="object-contain"
                            />
                          </div>
                          {!collapsed && <span>{item.name}</span>}
                        </div>
                        {!collapsed && (
                          <ChevronDown
                            className={`w-4 h-4 shrink-0 transition-transform ${isExpanded ? "rotate-180" : ""}`}
                          />
                        )}
                      </button>
                       {isExpanded && !collapsed && item.submenuStyle === "tree" && (
                        <ul className="relative mt-1 mb-2 ml-[30px] pl-4 border-l border-white/30 space-y-1">
                          {item.submenu.map((subItem) => {
                            const medsApi = Boolean(subItem.medsApi);
                            const abhaLogin = Boolean(subItem.abhaLogin);
                            const aiPreScreening = Boolean(subItem.aiPreScreening);
                            const nhcxSso = Boolean(subItem.nhcxSso);
                            const subHref = subItem.href;
                            const external =
                              !medsApi &&
                              !abhaLogin &&
                              !aiPreScreening &&
                              !nhcxSso &&
                              !subHref &&
                              isExternalHref(subHref);
                            const isSubActive =
                              subHref &&
                              !medsApi &&
                              !abhaLogin &&
                              !aiPreScreening &&
                              !nhcxSso &&
                              location.pathname === subHref;
                            const subClassName = `flex items-center gap-2.5 w-full py-2.5 pr-2 text-[13px] font-medium text-white/95 rounded-md transition hover:bg-white/10 ${
                              isSubActive ? "bg-emerald-400/40 font-semibold" : ""
                            } ${medsApi && medsApiLoading ? "opacity-60 pointer-events-none" : ""} ${
                              nhcxSso && nhcxSsoLoading ? "opacity-60 pointer-events-none" : ""
                            }`;
                            const treeRow = (
                              <>
                                <TreeSubmenuIcon subItem={subItem} />
                                <span className="leading-relaxed">{subItem.name}</span>
                              </>
                            );
                            return (
                              <li
                                key={subItem.name}
                                className="relative"
                              >
                                <span
                                  className="absolute -left-4 top-[13px] w-3.5 h-2.5 border-l border-b border-white/30 rounded-bl-md"
                                  aria-hidden
                                />
                                {medsApi ? (
                                  <button
                                    type="button"
                                    className={`${subClassName} text-left`}
                                    onClick={handleMedsApiClick}
                                  >
                                    {treeRow}
                                  </button>
                                ) : abhaLogin ? (
                                  <button
                                    type="button"
                                    className={`${subClassName} text-left cursor-pointer`}
                                    onClick={handleAbhaLoginClick}
                                  >
                                    {treeRow}
                                  </button>
                                ) : aiPreScreening ? (
                                  <button
                                    type="button"
                                    className={`${subClassName} text-left cursor-pointer`}
                                    onClick={handleAiPreScreeningClick}
                                  >
                                    {treeRow}
                                  </button>
                                ) : nhcxSso ? (
                                  <button
                                    type="button"
                                    className={`${subClassName} text-left cursor-pointer`}
                                    onClick={handleNhcxSsoClick}
                                  >
                                    {treeRow}
                                  </button>
                                ) : subHref ? (
                                  <Link
                                    to={subHref}
                                    onClick={() => {
                                      if (onNavigate) onNavigate();
                                    }}
                                    className={subClassName}
                                  >
                                    {treeRow}
                                  </Link>
                                ) : external ? (
                                  <a
                                    href={subHref}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={subClassName}
                                    onClick={() => {
                                      if (onNavigate) onNavigate();
                                    }}
                                  >
                                    {treeRow}
                                  </a>
                                ) : (
                                  <Link
                                    to={subItem.href}
                                    onClick={() => {
                                      if (onNavigate) onNavigate();
                                    }}
                                    className={subClassName}
                                  >
                                    {treeRow}
                                  </Link>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                      {isExpanded && !collapsed && item.submenuStyle !== "tree" && (
                        <ul
                          className={
                            item.submenuStyle === "bullets"
                              ? "ml-5 mt-2 space-y-2 border-l border-white/20 pl-4"
                              : "ml-4 mt-2 space-y-1"
                          }
                        >
                          {item.submenu.map((subItem) => {
                            const medsApi = Boolean(subItem.medsApi);
                            const abhaLogin = Boolean(subItem.abhaLogin);
                            const subHref = subItem.href;
                            const external =
                              !medsApi &&
                              !abhaLogin &&
                              !subHref &&
                              isExternalHref(subHref);
                            const isSubActive =
                              subHref &&
                              !medsApi &&
                              !abhaLogin &&
                              location.pathname === subHref;
                            const bullet = item.submenuStyle === "bullets";
                            const subClassName = `flex rounded-lg text-sm font-medium transition ${
                              bullet
                                ? "items-start gap-2.5 px-3 py-1.5"
                                : "items-center gap-3 px-4 py-2"
                            } ${
                              isSubActive
                                ? "bg-emerald-400/50 text-white font-semibold shadow-sm"
                                : "hover:bg-white/10 text-white/95"
                            } ${medsApi && medsApiLoading ? "opacity-60 pointer-events-none" : ""}`;
                            return (
                              <li key={subItem.name}>
                                {medsApi ? (
                                  <button
                                    type="button"
                                    className={`${subClassName} w-full text-left`}
                                    onClick={handleMedsApiClick}
                                  >
                                    {bullet && (
                                      <span
                                        className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-white"
                                        aria-hidden
                                      />
                                    )}
                                    <span className={bullet ? "leading-snug" : ""}>
                                      {subItem.name}
                                    </span>
                                  </button>
                                ) : abhaLogin ? (
                                  <button
                                    type="button"
                                    className={`${subClassName} w-full text-left cursor-pointer`}
                                    onClick={handleAbhaLoginClick}
                                  >
                                    {bullet && (
                                      <span
                                        className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-white"
                                        aria-hidden
                                      />
                                    )}
                                    <span className={bullet ? "leading-snug" : ""}>
                                      {subItem.name}
                                    </span>
                                  </button>
                                ) : external ? (
                                  <a
                                    href={subHref}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={subClassName}
                                    onClick={() => {
                                      if (onNavigate) onNavigate();
                                    }}
                                  >
                                    {bullet && (
                                      <span
                                        className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-white"
                                        aria-hidden
                                      />
                                    )}
                                    <span className={bullet ? "leading-snug" : ""}>
                                      {subItem.name}
                                    </span>
                                  </a>
                                ) : (
                                  <Link
                                    to={subItem.href}
                                    onClick={() => {
                                      if (onNavigate) onNavigate();
                                    }}
                                    className={subClassName}
                                  >
                                    {bullet && (
                                      <span
                                        className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-white"
                                        aria-hidden
                                      />
                                    )}
                                    <span className={bullet ? "leading-snug" : ""}>
                                      {subItem.name}
                                    </span>
                                  </Link>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </>
                  ) : (
                    <Link
                      to={item.href}
                      title={collapsed ? item.name : ""}
                      onClick={() => { if (onNavigate) onNavigate(); }}
                      className={`flex items-center ${collapsed ? "justify-center" : "gap-3"
                        } w-full px-4 py-2 text-sm font-medium rounded-lg transition ${isActive
                          ? "bg-emerald-400/50 text-white font-semibold shadow-sm"
                          : "hover:bg-white/10 text-white"
                        }`}
                    >
                      <div
                        className={`w-10 h-10 flex items-center justify-center rounded-lg `}
                      >
                        <img
                          src={icon}
                          width={20}
                          height={20}
                          alt={item.name}
                          className="object-contain"
                        />
                      </div>
                      {!collapsed && <span>{item.name}</span>}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
      </nav>
      <div className="flex-shrink-0 px-4 py-4 border-t border-white/30">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 text-sm font-medium hover:bg-white/10 rounded-lg px-3 py-2 transition w-full text-left"
        >
          <LogOut className="h-5 w-5" />
          {!collapsed && "Log Out"}
        </button>
      </div>
    </div>
  );
}
